import styled from 'styled-components';
import media from '../../../constants/media';

export const Wrapper = styled.div`
	margin: 6rem 0;

	${media.tablet`
		margin: 12rem 0;
	`};
`;
